import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'idp-base-flyout-summary-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './base-flyout-summary-header.component.html',
  styleUrl: './base-flyout-summary-header.component.scss'
})
export class BaseFlyoutSummaryHeaderComponent {
  getMedallionFlag(
    medFlag: string,
    isTier360: boolean,
    isMillionMiler: boolean
  ): string {
    if (isTier360) {
      return 'DM360';
    }

    if (isMillionMiler) {
      return 'MM';
    }

    return medFlag;
  }
}
